export default __webpack_public_path__ + "static/ai-solutions-with-roadmap4-e30b9e2a30276f6832d241b63277a59a.jpg";